import { j as g, t as T, a as H } from "../../utils-BdNIfrGQ.js";
import * as m from "react";
import i from "react";
import { S as W } from "../../index-5pXbvMI7.js";
import { L as Fe, R as pe } from "../../Label-kWLyCHVQ.js";
var G = (e) => e.type === "checkbox", q = (e) => e instanceof Date, k = (e) => e == null;
const K = (e) => typeof e == "object";
var b = (e) => !k(e) && !Array.isArray(e) && K(e) && !q(e), z = (e) => b(e) && e.target ? G(e.target) ? e.target.checked : e.target.value : e, J = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, Q = (e, s) => e.has(J(s)), X = (e) => {
  const s = e.constructor && e.constructor.prototype;
  return b(s) && s.hasOwnProperty("isPrototypeOf");
}, Y = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function R(e) {
  let s;
  const t = Array.isArray(e), o = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    s = new Date(e);
  else if (!(Y && (e instanceof Blob || o)) && (t || b(e)))
    if (s = t ? [] : {}, !t && !X(e))
      s = e;
    else
      for (const r in e)
        e.hasOwnProperty(r) && (s[r] = R(e[r]));
  else
    return e;
  return s;
}
var M = (e) => /^\w*$/.test(e), h = (e) => e === void 0, Z = (e) => Array.isArray(e) ? e.filter(Boolean) : [], O = (e) => Z(e.replace(/["|']|\]/g, "").split(/\.|\[/)), c = (e, s, t) => {
  if (!s || !b(e))
    return t;
  const o = (M(s) ? [s] : O(s)).reduce((r, n) => k(r) ? r : r[n], e);
  return h(o) || o === e ? h(e[s]) ? t : e[s] : o;
}, v = (e) => typeof e == "boolean", E = (e, s, t) => {
  let o = -1;
  const r = M(s) ? [s] : O(s), n = r.length, l = n - 1;
  for (; ++o < n; ) {
    const u = r[o];
    let a = t;
    if (o !== l) {
      const f = e[u];
      a = b(f) || Array.isArray(f) ? f : isNaN(+r[o + 1]) ? {} : [];
    }
    if (u === "__proto__" || u === "constructor" || u === "prototype")
      return;
    e[u] = a, e = e[u];
  }
};
const N = {
  BLUR: "blur",
  CHANGE: "change"
}, P = {
  all: "all"
}, C = i.createContext(null);
C.displayName = "HookFormContext";
const p = () => i.useContext(C), ee = (e) => {
  const { children: s, ...t } = e;
  return i.createElement(C.Provider, { value: t }, s);
};
var te = (e, s, t, o = !0) => {
  const r = {
    defaultValues: s._defaultValues
  };
  for (const n in e)
    Object.defineProperty(r, n, {
      get: () => {
        const l = n;
        return s._proxyFormState[l] !== P.all && (s._proxyFormState[l] = !o || P.all), t && (t[l] = !0), e[l];
      }
    });
  return r;
};
const L = typeof window < "u" ? m.useLayoutEffect : m.useEffect;
function re(e) {
  const s = p(), { control: t = s.control, disabled: o, name: r, exact: n } = e || {}, [l, u] = i.useState(t._formState), a = i.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  });
  return L(() => t._subscribe({
    name: r,
    formState: a.current,
    exact: n,
    callback: (f) => {
      !o && u({
        ...t._formState,
        ...f
      });
    }
  }), [r, o, n]), i.useEffect(() => {
    a.current.isValid && t._setValid(!0);
  }, [t]), i.useMemo(() => te(l, t, a.current, !1), [l, t]);
}
var se = (e) => typeof e == "string", oe = (e, s, t, o, r) => se(e) ? c(t, e, r) : Array.isArray(e) ? e.map((n) => c(t, n)) : t;
function ne(e) {
  const s = p(), { control: t = s.control, name: o, defaultValue: r, disabled: n, exact: l } = e || {}, u = i.useRef(r), [a, f] = i.useState(t._getWatch(o, u.current));
  return L(() => t._subscribe({
    name: o,
    formState: {
      values: !0
    },
    exact: l,
    callback: (F) => !n && f(oe(o, t._names, F.values || t._formValues, !1, u.current))
  }), [o, t, n, l]), i.useEffect(() => t._removeUnmounted()), a;
}
function ae(e) {
  const s = p(), { name: t, disabled: o, control: r = s.control, shouldUnregister: n } = e, l = Q(r._names.array, t), u = ne({
    control: r,
    name: t,
    defaultValue: c(r._formValues, t, c(r._defaultValues, t, e.defaultValue)),
    exact: !0
  }), a = re({
    control: r,
    name: t,
    exact: !0
  }), f = i.useRef(e), F = i.useRef(r.register(t, {
    ...e.rules,
    value: u,
    ...v(e.disabled) ? { disabled: e.disabled } : {}
  })), V = i.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!c(a.errors, t)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!c(a.dirtyFields, t)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!c(a.touchedFields, t)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!c(a.validatingFields, t)
    },
    error: {
      enumerable: !0,
      get: () => c(a.errors, t)
    }
  }), [a, t]), S = i.useCallback((d) => F.current.onChange({
    target: {
      value: z(d),
      name: t
    },
    type: N.CHANGE
  }), [t]), I = i.useCallback(() => F.current.onBlur({
    target: {
      value: c(r._formValues, t),
      name: t
    },
    type: N.BLUR
  }), [t, r._formValues]), w = i.useCallback((d) => {
    const _ = c(r._fields, t);
    _ && d && (_._f.ref = {
      focus: () => d.focus && d.focus(),
      select: () => d.select && d.select(),
      setCustomValidity: (y) => d.setCustomValidity(y),
      reportValidity: () => d.reportValidity()
    });
  }, [r._fields, t]), A = i.useMemo(() => ({
    name: t,
    value: u,
    ...v(o) || a.disabled ? { disabled: a.disabled || o } : {},
    onChange: S,
    onBlur: I,
    ref: w
  }), [t, o, a.disabled, S, I, w, u]);
  return i.useEffect(() => {
    const d = r._options.shouldUnregister || n;
    r.register(t, {
      ...f.current.rules,
      ...v(f.current.disabled) ? { disabled: f.current.disabled } : {}
    });
    const _ = (y, $) => {
      const x = c(r._fields, y);
      x && x._f && (x._f.mount = $);
    };
    if (_(t, !0), d) {
      const y = R(c(r._options.defaultValues, t));
      E(r._defaultValues, t, y), h(c(r._formValues, t)) && E(r._formValues, t, y);
    }
    return !l && r.register(t), () => {
      (l ? d && !r._state.action : d) ? r.unregister(t) : _(t, !1);
    };
  }, [t, r, l, n]), i.useEffect(() => {
    r._setDisabledField({
      disabled: o,
      name: t
    });
  }, [o, t, r]), i.useMemo(() => ({
    field: A,
    formState: a,
    fieldState: V
  }), [A, a, V]);
}
const ie = (e) => e.render(ae(e)), D = (...e) => T(H(e)), ye = ee, j = m.createContext({}), ge = ({
  ...e
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
}) => /* @__PURE__ */ g.jsx(j.Provider, { value: { name: e.name }, children: /* @__PURE__ */ g.jsx(ie, { ...e }) }), B = m.createContext({}), U = () => {
  const e = m.useContext(j), s = m.useContext(B), { getFieldState: t, formState: o } = p(), r = t(e.name, o);
  if (!e)
    throw new Error("useFormField should be used within <FormField>");
  const { id: n } = s;
  return {
    id: n,
    name: e.name,
    formItemId: `${n}-form-item`,
    formDescriptionId: `${n}-form-item-description`,
    formMessageId: `${n}-form-item-message`,
    ...r
  };
}, le = m.forwardRef(
  ({ className: e, ...s }, t) => {
    const o = m.useId();
    return /* @__PURE__ */ g.jsx(B.Provider, { value: { id: o }, children: /* @__PURE__ */ g.jsx("div", { ref: t, className: D("", e), ...s }) });
  }
);
le.displayName = "FormItem";
const ue = m.forwardRef(({ ...e }, s) => {
  const { error: t, formItemId: o, formDescriptionId: r, formMessageId: n } = U();
  return /* @__PURE__ */ g.jsx(
    W,
    {
      ref: s,
      id: o,
      "aria-describedby": t ? `${r} ${n}` : `${r}`,
      "aria-invalid": !!t,
      ...e
    }
  );
});
ue.displayName = "FormControl";
const ce = m.forwardRef(({ className: e, children: s, ...t }, o) => {
  const { error: r, formMessageId: n } = U(), l = r ? String(r?.message ?? "") : s;
  return l ? /* @__PURE__ */ g.jsx(
    "p",
    {
      ref: o,
      id: n,
      className: D("text-[0.8rem] font-medium text-destructive", e),
      ...t,
      children: l
    }
  ) : null;
});
ce.displayName = "FormMessage";
export {
  ye as Form,
  ue as FormControl,
  ge as FormField,
  le as FormItem,
  ce as FormMessage,
  Fe as Label,
  pe as RequiredBadge,
  U as useFormField
};
